import { useCallback } from "react";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch";
import { updateReport } from "../../../../store/thunks/currentReportThunks";
import { fieldsStateActions } from "../../../../store/thunks/fieldStatesThunks";
import type { ReportType } from "../../../../../../../../api/types/svTypes.ts";

const useReportTypeChange = () => {
  const dispatch = useAppDispatch();

  const onReportTypeChanged = useCallback(
    (reportType: ReportType) => {
      dispatch(updateReport({ reportType }));
      dispatch(fieldsStateActions.handleReportTypeChange(reportType));
    },
    [dispatch]
  );

  return { onReportTypeChanged };
};

export default useReportTypeChange;
